import { Component, Input, OnInit } from '@angular/core';
import { ClearancelevelEnum } from 'src/app/constants/clearance-levels.enum';
import { BuilderRequest } from 'src/app/models/requests';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-reviewandsendsummary',
  templateUrl: './reviewandsendsummary.component.html'
})
export class ReviewandsendsummaryComponent implements OnInit {

  get request(): BuilderRequest {
    return this._request;
  }
  @Input('request') set request(val: BuilderRequest) {
    this._request = val
    if(this._request.workgroup != null && this._request.workgroup != undefined){
      this.MaxClearanceOfWorkgroup = (this.authenticationService.workgroups.find(workgroup => workgroup.Guid === this._request.workgroup)?.Clearancelevel as ClearancelevelEnum)
    }
  }
  @Input() requestType!: string;
  private _request!: BuilderRequest;
  MaxClearanceOfWorkgroup: number = ClearancelevelEnum.One;

  constructor(private authenticationService: AuthenticationService) {
    // Must not be empty. It's approved by a comment.
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  MaxClearnaceIsNotOne(){
    return this.MaxClearanceOfWorkgroup != ClearancelevelEnum.One;
  }
  
}
